import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { undoRecurring, type RecurringItem, type RecurringUndoable } from '@/api/recurring'
import { formatDate } from '@/lib/formatDate'

export function undoLabel(item: RecurringItem, step: RecurringUndoable): string {
  switch (step.action) {
    case 'DONE':
      return `Undo ${item.type === 'EXPENSE' ? 'paid' : 'received'} · ${formatDate(step.dueDateBefore)}`
    case 'MISSED':
      return `Undo missed · ${formatDate(step.dueDateBefore)}`
    case 'RESCHEDULE':
      return `Undo date change · back to ${formatDate(step.dueDateBefore)}`
  }
}

// Undoing a payment deletes it, so every money view can change, not just Recurring.
const AFFECTED = [
  'recurring',
  'calendar',
  'accounts',
  'transactions',
  'dashboard',
  'budget',
  'loan',
  'contacts',
]

export function useUndoRecurring(itemId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => undoRecurring(itemId),
    onSuccess: () => {
      for (const key of AFFECTED) queryClient.invalidateQueries({ queryKey: [key] })
      toast.success('Undone')
    },
    onError: (err) =>
      toast.error(
        (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail ??
          "Couldn't undo. Please try again."
      ),
  })
}
